export default __webpack_public_path__ + "static/gulfstream-III-424-6c4c75c136691b463c1c9a002f2387f6.jpg";